import { getCurrentLocale } from '@/utils/i18n';

export abstract class ObjectMapper {
    static getTranslatedName(labelList: Label[] | undefined): string | undefined {
        // Cas legitime et frequent (objet sans labelList) : on retourne
        // silencieusement plutot que de spammer la console (etait un console.error
        // appele par objet => des centaines de lignes qui noyaient la vraie console).
        if (!labelList || !Array.isArray(labelList)) {
            return undefined;
        }

        const currentLocale: string = getCurrentLocale().toUpperCase();

        const label: Label | undefined = labelList.find((label: any) => {
            return label.langValue === currentLocale;
        });

        return label?.label;
    }
}
